import { useMutation, useQuery } from "@tanstack/react-query";

import fetchJSON from "../lib/reactQueryClient";
import {
  REACT_APP_UPLOAD_SERVICE_SECRET_KEY,
  REACT_APP_UPLOAD_SERVICE_URL,
} from "../constants/constants";

const uploadFileService = async ({ selectedFile, userId, scriptId }) => {
  const url = new URL(
    `${REACT_APP_UPLOAD_SERVICE_URL}/upload-file?uploaded_by=${userId}&selected_script_id=${scriptId}`,
  );
  const formData = new FormData();
  formData.append("file", selectedFile);

  return fetchJSON(url, {
    method: "POST",
    headers: {
      accept: "application/json",
      "secret-key": REACT_APP_UPLOAD_SERVICE_SECRET_KEY,
    },
    body: formData,
  });
};

export const useUploadFileService = () => {
  return useMutation({ mutationFn: uploadFileService });
};

const fetchUploadedFileHistory = async ({ moduleId, offset = 0, limit = 10 }) => {
  const url = new URL(`${REACT_APP_UPLOAD_SERVICE_URL}/get-all-files`);
  url.searchParams.set("module_id", String(moduleId));
  url.searchParams.set("offset", String(offset));
  url.searchParams.set("limit", String(limit));

  return fetchJSON(url, {
    method: "GET",
    headers: {
      accept: "application/json",
      "secret-key": REACT_APP_UPLOAD_SERVICE_SECRET_KEY,
    },
  });
};

export const useFetchUploadedFileHistory = ({ moduleId, offset = 0, limit = 10 }) => {
  return useQuery({
    queryKey: ["uploadedFileHistory", moduleId, offset, limit],
    queryFn: () => fetchUploadedFileHistory({ moduleId, offset, limit }),
    enabled: !!moduleId,
  });
};

const fetchProcessedFileUploadService = async (fileId) => {
  const url = new URL(
    `${REACT_APP_UPLOAD_SERVICE_URL}/download-processed-file/${fileId}`,
  );
  const response = await fetchJSON(url, {
    method: "GET",
    headers: {
      accept: "application/json",
      "secret-key": REACT_APP_UPLOAD_SERVICE_SECRET_KEY,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const useFetchProcessedFileUploadService = () => {
  return useMutation({
    mutationFn: (fileId) => fetchProcessedFileUploadService(fileId),
  });
};
